import NewCategoriesFilter from './NewCategoriesFilter';

export default NewCategoriesFilter;
